import { RiskBadge, StatusCell } from "@/components/assessment/results/StatusCell";
import { LEVEL_LABELS } from "@/lib/level-badge";
import { HORIZON_LABELS, resultRowLabel } from "@/lib/results";
import type { ReportModel } from "@/lib/report";
import { BASIS_TEXT } from "@/lib/report-basis";
import { SectionHeading } from "./ReportPage";

export function ReportTopRisks({ model }: { model: ReportModel }) {
  const caveatHazards = new Set(model.caveats.flatMap((c) => c.hazards));

  return (
    <section className="space-y-3">
      <div>
        <SectionHeading>Highest gross risks</SectionHeading>
        {model.topRisks.length > 0 && (
          <p className="mt-1 text-xs text-muted-foreground">
            Top {model.topRisks.length} asset–hazard combinations. {BASIS_TEXT.topRisksNote}
          </p>
        )}
      </div>

      {model.topRisks.length === 0 ? (
        <p className="text-sm text-muted-foreground">No asset–hazard combination has a computed score yet.</p>
      ) : (
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-muted-foreground">
              <th className="p-2 font-medium">Asset</th>
              <th className="p-2 font-medium">Value chain stage</th>
              <th className="p-2 font-medium">Hazard</th>
              <th className="p-2 font-medium">Importance</th>
              {model.horizons.map((h) => (
                <th key={h} className="p-2 font-medium">
                  {HORIZON_LABELS[h]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {model.topRisks.map((r) => (
              <tr key={`${r.assetId}|${r.key}`} className="break-inside-avoid border-t border-border">
                <td className="p-2 font-medium">{r.assetName}</td>
                <td className="p-2">{r.stageName ?? "—"}</td>
                <td className="p-2">
                  {resultRowLabel({ hazardType: r.hazardType, season: r.cells.find((c) => c.cell)?.cell?.season })}
                  {caveatHazards.has(r.hazardType) && " †"}
                </td>
                <td className="p-2">{LEVEL_LABELS[r.importance]}</td>
                {r.cells.map(({ horizon, cell }) => (
                  <td key={horizon} className="p-2">
                    <StatusCell cell={cell} renderComputed={(c) => <RiskBadge cell={c} />} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
